import $ from 'jquery'
import Splide from '@splidejs/splide'
let isScrolling = false

const wheelEvent = (event) => {
  if (isScrolling) {
    return
  }
  if (event.deltaY > 0) {
    projectSplide.go('>')
  } else {
    projectSplide.go('<')
  }
  isScrolling = true
  setTimeout(() => {
    isScrolling = false
  }, 1000)
}

const addWheelEvent = () => {
  window.addEventListener('wheel', wheelEvent)
}

const removeWheelEvent = () => {
  window.removeEventListener('wheel', wheelEvent)
}

if ($('.slider-page__slider').length != 0) {
  var projectSplide = new Splide('.slider-page__slider', {
    perPage: 1,
    perMove: 1,
    type: 'fade',
    arrows: false,
    drag: false,
    breakpoints: {
      992: {
        destroy: true,
      },
    },
  })

  projectSplide.mount()
}

$(document).ready(function () {
  addWheelEvent()
  function updatePaginationPosition() {
    let textColWidth = $('.js-text-col').width()
    let newPosition = textColWidth + 24
    $('.splide__pagination').css('right', newPosition + '%')
  }

  updatePaginationPosition()

  $(window).resize(function () {
    updatePaginationPosition()
  })

  $('.slider-page__slide--text')
    .on('mouseenter', function () {
      removeWheelEvent()
    })
    .on('mouseleave', function () {
      addWheelEvent()
    })
})

$('.js-next').on('click', function () {
  projectSplide.go('>')
})

$('.js-prev').on('click', function () {
  projectSplide.go('<')
})

$('.js-open-accordion').click(function () {
  if ($(this).hasClass('is-active')) {
    $(this).removeClass('is-active')
    $(this).parent().find('.js-accordion-body').slideUp()
  } else {
    $(this).addClass('is-active')
    $(this).parent().find('.js-accordion-body').slideDown()
  }
})
